import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["srcdoc"];
import { ref, computed, onMounted } from 'vue';
export default {
  __name: 'LlHtmlViewerIframe',
  props: {
    htmlContent: {
      type: String,
      required: true
    },
    additionalStyles: {
      type: String,
      default: ''
    },
    customContainerClass: {
      type: String,
      default: ''
    },
    customIframeClass: {
      type: String,
      default: ''
    },
    enableAdditionalStyle: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const iframe = ref(null);
    const processedHtmlContent = computed(() => {
      const parentStyles = `
    <style>
      body {
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; 
        font-size: 13px;
        color: #333333;
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }
      /* Add any additional default styles here */
    </style>
  `;
      const additionalStyles = props.enableAdditionalStyle ? props.additionalStyles : '';
      return `
    ${parentStyles}
    ${additionalStyles}
    ${props.htmlContent}
  `;
    });
    const adjustIframeHeight = () => {
      const iframeElement = iframe.value;
      if (iframeElement) {
        iframeElement.onload = () => {
          const iframeDocument = iframeElement.contentDocument || iframeElement.contentWindow.document;
          iframeElement.style.height = `${iframeDocument.body.scrollHeight}px`;
        };
      }
    };
    onMounted(() => {
      adjustIframeHeight();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['iframe-container', __props.customContainerClass])
      }, [_createElementVNode("iframe", {
        ref_key: "iframe",
        ref: iframe,
        srcdoc: processedHtmlContent.value,
        frameborder: "0",
        class: _normalizeClass(['responsive-iframe', __props.customIframeClass]),
        sandbox: "allow-same-origin allow-scripts"
      }, null, 10, _hoisted_1)], 2);
    };
  }
};